import {
  Modal as ModalType,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import ReportView from "client/views/ReportView"
import FullscreenModal from "shared/components/FullscreenModal"

const ModalLayer = () => {
  const {
    state: { isReportModalOpen },
    setModalOpen,
  } = useGlobalContext()

  return (
    <>
      {isReportModalOpen && (
        <FullscreenModal
          closeModal={() => setModalOpen(ModalType.REPORT, false)}
        >
          <ReportView />
        </FullscreenModal>
      )}
    </>
  )
}

export default ModalLayer
